import styles from '../centralAntrag.module.css';
import stylesFlex from './flexkarteBestellen.module.css';
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { program, month, flexkarte, beteiligung, evaluation, accept } from '../../../../../config/meta-informationen';
import { showErrorToast } from '../../../../../code/ToastHelper';
function FlexkarteBestellen() {
    const navigate = useNavigate();
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, '0')}.${String(today.getMonth() + 1).padStart(2, '0')}.${today.getFullYear()}`;

    const [formData, setFormData] = useState({
        formType: "orderFlexkarte",
        dateToday: formattedDate,
        flexkarte: "",
        firstName: "",
        familyName: "",
        birthdate: "",
        email: "",
        street: "",
        housenumber: "",
        zusatz: "",
        plz: "",
        area: "",
        dataSecurity: "",
        einverstaendnisOeffentlichkeit: "",
        bereich: "",
        ideen: "",
        evaluation: "",
        anderes: "",
        month: "",
        program: []

    });

    const handleChange = (e) => {
        const { name, value, type, options } = e.target;

        if (type === 'select-multiple') {
            const selected = Array.from(options)
                .filter((opt) => opt.selected)
                .map((opt) => opt.value);

            setFormData((prev) => ({
                ...prev,
                [name]: selected,
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await fetch("/api/email/send-emails", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (response.ok) {
                setSubmitted(true);
            } else {
                showErrorToast("Fehler beim Senden: " + result.message)
            }
        } catch (error) {
            console.error("Ein Fehler ist aufgetreten:", error);
            showErrorToast("Beim Senden der Anfrage ist ein Fehler aufgetreten.");
        }
        setLoading(false);
    };

    return (
        <section className={styles.container}>
            <h1>Flexkarte bestellen</h1>

            {!submitted ? (
                <form className={styles.formular} onSubmit={handleSubmit}>
                    {/* Auswahl Flexkarte */}
                    <div className={styles.section}>
                        <p className={styles.sectionTitle}>Auswahl Flexkarte</p>
                        <div className={styles.areaSpecial}>
                            <div>Wähle eine Flexkarte aus: <span className={styles.required}>*</span></div>
                            <div className={stylesFlex.flexkarteOptions}>
                                {Object.entries(flexkarte).map(([key, label], index) => {

                                    return (
                                        <div key={key} className={stylesFlex.flexkarteOption}>
                                            <input
                                                type="radio"
                                                name="flexkarte"
                                                value={key}
                                                id={`flexkarte-${key}`}
                                                onChange={(e) => {
                                                    const selectedKey = e.target.value;
                                                    const selectedOption = flexkarte[selectedKey];
                                                    setFormData({
                                                        ...formData,
                                                        flexkarte: {
                                                            key: selectedKey,
                                                            ...selectedOption
                                                        }
                                                    });
                                                }}
                                                required={index === 0}
                                            />
                                            <label htmlFor={`flexkarte-${key}`}>
                                                <table className={styles.flexTable}>
                                                    <tr>
                                                        <td className={stylesFlex.arrayTitle}>{label.title}</td>
                                                        <td className={stylesFlex.arrayPrice}>{label.price}</td>
                                                        <td className={stylesFlex.arrayDescription}>{label.description}</td>
                                                    </tr>
                                                </table>
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                    </div>
                    {/* Allgemeine Informationen */}
                    <div className={styles.section}>
                        <p className={styles.sectionTitle}>Allgemeine Informationen</p>
                        <div className={styles.area}>
                            <label>
                                <div>Vorname<span className={styles.required}>*</span></div>
                                <input type="text" name="firstName" placeholder='Max' required onChange={handleChange} />
                            </label>
                            <label>
                                <div>Nachname<span className={styles.required}>*</span></div>
                                <input type="text" name="familyName" placeholder='Mustermann' required onChange={handleChange} />
                            </label>
                        </div>
                        <div className={styles.area}>
                            <label>
                                <div>Geburtsdatum<span className={styles.required}>*</span></div>
                                <input type="date" name="birthdate" placeholder='Max' required onChange={handleChange} />
                            </label>
                            <label className={styles.big}>
                                <div>E-Mail<span className={styles.required}>*</span></div>
                                <input type="email" name="email" placeholder='max.mustermann@muster-adresse.de' required onChange={handleChange} />
                            </label>
                        </div>
                    </div>
                    {/* Adresse */}
                    <div className={styles.section}>
                        <p className={styles.sectionTitle}>Adresse</p>
                        <div className={styles.area}>
                            <label className={styles.big}>
                                <div>Straße<span className={styles.required}>*</span></div>
                                <input type="text" name="street" placeholder='Musterstraße' required onChange={handleChange} />
                            </label>
                            <label className={styles.small}>
                                <div>Hausnummer<span className={styles.required}>*</span></div>
                                <input type="text" name="housenumber" placeholder='3a' required onChange={handleChange} />
                            </label>
                        </div>
                        <div className={styles.area}>
                            <label>
                                <div>Zusatz</div>
                                <input type="text" name="zusatz" placeholder='Hinterhof' onChange={handleChange} />
                            </label>
                        </div>
                        <div className={styles.area}>
                            <label className={styles.small}>
                                <div>PLZ<span className={styles.required}>*</span></div>
                                <input type="text" name="plz" placeholder='53639' pattern="\d{5}" required onChange={handleChange}
                                    maxLength={5}
                                    inputMode="numeric"
                                    title="Bitte eine fünfstellige Postleitzahl eingeben"
                                />
                            </label>
                            <label className={styles.big}>
                                <div>Ort<span className={styles.required}>*</span></div>
                                <input type="text" name="area" placeholder='Königswinter' required onChange={handleChange} />
                            </label>

                        </div>
                    </div>
                    {/* Datenschutzhinweis */}
                    <div className={styles.section}>
                        <div>
                            <p className={styles.sectionTitle}>Datenschutzhinweis</p>
                        </div>
                        <div className={styles.area}>
                            <div className={styles.areaSpecial}>
                                <p>Ich habe die sich auf der Homepage des Vereins (tus05-oberpleis.de) befindlichen Datenschutzhinweis gelesen und erkläre mich hiermit einverstanden. Sie können Ihre erteilte Einwilligung jederzeit mit Wirkung für die Zukunft gem. Art. 7 Abs. 3 DSGVO widerrufen. Ebenso können Sie der künftigen Verarbeitung der Sie betreffenden Daten nach Maßgabe des Art. 21 DSGVO jederzeit widersprechen: <span tabIndex={0} onClick={() => { navigate("/datenschutz") }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {

                                            e.preventDefault(); // Prevent space from scrolling
                                            navigate("/datenschutz")
                                        }
                                    }}>Datenschutzerklärung</span></p>
                                <label>
                                    <div>Ich stimme der Datenschutzerklärung zu:</div>
                                    <div><input type="checkbox" name="dataSecurity" required onChange={handleChange} /><span className={styles.required}>*</span></div>

                                </label>
                            </div>
                        </div>
                    </div>
                    {/* Einverständniserklärung Öffentlichkeitsarbeit */}
                    <div className={styles.section}>
                        <div>
                            <p className={styles.sectionTitle}>Einverständniserklärung Öffentlichkeitsarbeit</p>
                        </div>
                        <div className={styles.areaSpecial}>
                            <div>Hiermit erkläre ich mich einverstanden, dass Berichte/ Bilder von mir und/oder meinen Kindern, die im Rahmen von Training, Spielen oder sonstigen Veranstaltungen des TuS 05 Oberpleis e.V. für Zwecke der Öffentlichkeitsarbeit unter Beifügung des Namens auf der Vereinshomepage und/ oder den offiziellen Social-Media-Kanälen des Vereins sowie in sonstigen Publikationen (z.B. Vereinsheft, Tageszeitungen, fußball.de, etc.) genutzt und veröffentlicht werden dürfen. Dies umschließt Einzel- und Mannschaftsfotos, sowie sonstige Situationsaufnahmen. Diese Einwilligung kann jederzeit durch eine Nachricht in Textform an geschaeftsstelle@tus05-oberpleis.de oder per Brief an TuS 05 Oberpleis e.V., Humboldtstr. 3a 53639 Königswinter widerrufen werden.<span className={styles.required}>*</span></div>
                            {Object.entries(accept).map(([key, label], index) => (
                                <label key={key}>
                                    <input type="radio" name="einverstaendnisOeffentlichkeit" value={key} onChange={handleChange}
                                        required={index === 0} />
                                    {label}
                                </label>
                            ))}
                        </div>
                    </div>
                    {/* Vereinsarbeit und -entwicklung */}
                    <div className={styles.section}>
                        <div>
                            <p className={styles.sectionTitle}>Vereinsarbeit und -entwicklung</p>
                        </div>
                        <div className={styles.areaSpecial}>
                            <p>Interesse an aktiver Vereinsarbeit im:</p>
                            {Object.entries(beteiligung).map(([key, label]) => (
                                <label key={key}>
                                    <input type="radio" name="bereich" value={label}
                                        onChange={(e) => setFormData({ ...formData, bereich: e.target.value })}
                                        checked={formData.bereich === label} />
                                    {label}
                                </label>
                            ))}
                        </div>
                        <label>
                            <div>Ideen im Rahmen der Vereinsentwicklung (neue Sport-/ Freizeitangebote):</div>
                            <textarea name="ideen" placeholder="Hinweis auf bestehende Einzelmitgliedschaft, Wunsch nach Wechsel auf Familienmitgliedschaft" onChange={handleChange}></textarea>
                        </label>
                    </div>
                    {/* Evaluation */}
                    <div className={styles.section}>
                        <div>
                            <p className={styles.sectionTitle}>Evaluation</p>
                        </div>
                        <div className={styles.area}>
                            <div className={styles.areaSpecial}>
                                <p>Ich habe vom TuS über ... erfahren:</p>
                                {Object.entries(evaluation).map(([key, label]) => (
                                    <label key={key}>
                                        <input
                                            type="radio"
                                            name="evaluation"
                                            value={label}
                                            onChange={(e) => setFormData({ ...formData, evaluation: e.target.value })}
                                            checked={formData.evaluation === label}
                                        />
                                        {label}
                                    </label>
                                ))}
                                <div>
                                    <label>
                                        <input
                                            type="text"
                                            name="anderes"
                                            value={formData.anderes}
                                            onChange={handleChange}
                                            disabled={formData.evaluation !== "Anderes"}
                                            placeholder='Wie haben Sie von uns erfahren?'
                                            style={{
                                                backgroundColor: formData.evaluation !== "Anderes" ? '#e0e0e0' : 'white',
                                            }}
                                        />
                                    </label>
                                </div>
                            </div>

                            <label>
                                <div>Ich habe am kostenfreien Kursangebot von SPORTout seit Monat / 2023 teilgenommen:</div>
                                <select
                                    name="month"
                                    value={formData.month}
                                    onChange={handleChange}
                                >
                                    <option value="" disabled>Wähle den Monat...</option>
                                    {Object.keys(month).map((key) => (
                                        <option key={key} value={key}>
                                            {month[key]}
                                        </option>
                                    ))}
                                </select>
                            </label>
                        </div>
                        <div>
                            <label>
                                <div>An folgendem Sportout Programm habe ich bereits teilgenommen:</div>
                                <select
                                    name="program"
                                    value={formData.program}
                                    onChange={handleChange}
                                    multiple
                                >
                                    <option value="" disabled>Wähle die Programme...</option>
                                    {Object.entries(program).map(([key, value]) => (
                                        <option key={key} value={value}>
                                            {value}
                                        </option>
                                    ))}
                                </select>
                            </label>
                        </div>
                    </div>
                    <button type="submit" disabled={loading}>
                        {loading ? (
                            <>
                                <span className={styles.spinner} /> Wird gesendet...
                            </>
                        ) : (
                            "Absenden"
                        )}
                    </button>
                </form>
            ) : (
                <div className={styles.bestaetigung}>
                    <img src='/images/logo.png' alt='Logo: TuS-05-Oberpleis'></img>
                    <div className={styles.text}>
                        <p>Der Antrag zur Mitgliedschaft wurde erfolgreich übermittelt!</p>
                        <p>Sie erhalten zusätzlich eine Bestätigung per E-Mail.</p>
                    </div>
                    <img className={styles.secondImg} src='/images/logo.png' alt='Logo: TuS-05-Oberpleis'></img>
                </div>
            )}
        </section >
    )
}

export default FlexkarteBestellen;